import { m } from 'framer-motion'

import IconButton from '@mui/material/IconButton'

import { varTap, varHover, transitionTap } from 'src/components/shared/animate'
import UserAvatar from './user-avatar'

// ----------------------------------------------------------------------

export function AccountButton({ userInitials, sx, ...other }) {
  return (
    <IconButton
      component={m.button}
      whileTap={varTap(0.96)}
      whileHover={varHover(1.04)}
      transition={transitionTap()}
      sx={[{ p: 0 }, ...(Array.isArray(sx) ? sx : [sx])]}
      {...other}
    >
      <UserAvatar sx={{ p: '3px' }} label={userInitials} />
    </IconButton>
  )
}
